// Partition items by enrollment: enrolled items first (tagged with `enrolled: true`),
// then the rest. Input order is preserved within each group. Returns [] when the only
// item is one the user is already enrolled in — there's nothing left to browse.
export const sortByEnrollment = (items, enrolledIds) => {
  if (!items?.length) return items;

  const enrolled = [];
  const rest = [];
  for (const item of items) {
    if (item?.id != null && enrolledIds.has(item.id)) {
      enrolled.push({ ...item, enrolled: true });
    } else {
      rest.push(item);
    }
  }

  if (items.length === 1 && enrolled.length === 1) return [];
  return [...enrolled, ...rest];
};
